import gql from 'graphql-tag'

export default gql`query getCourse ($id: Int!) {
	getCourse(id: $id) {
		id
		public_type
		visit_type
		status
    image
		details {
      id
			title
			duration
			start_title
			start_sub_title
			start_content
			end_title
			end_sub_title
			end_content
			language_code
		}
		updated_at
	}
}
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/course/get.js